import { render } from "./AddIcon.vue?vue&type=template&id=d64c4c92&scoped=true"
import script from "./AddIcon.vue?vue&type=script&lang=js"
export * from "./AddIcon.vue?vue&type=script&lang=js"

import "./AddIcon.vue?vue&type=style&index=0&id=d64c4c92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64c4c92"]])

export default __exports__